<template>
	<div class="cyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @qrsFn="subFn" @callFn="fxFlag = false" :title="`您正在获取班级试卷`">
			<p class="fxP">请选择需要获取的试卷</p>
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="60px">
				<el-form-item label="试 卷" prop="examId">
					<el-select style="width: 100%" v-model="ruleForm.examId" filterable allow-create default-first-option placeholder="请选择">
						<el-option v-for="item in bjList" :key="item.groupExamId" :label="item.title" :value="item.groupExamId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<dialogBox :dialogFlag="delFlag" rigTxt="确认删除" rigBg="#D33931" @callFn="delFlag = false" :title="''">
			<div class="delBox">
				<img src="@/assets/img/sc (6).png" alt="" />
				<h2>删除试卷后将无法恢复</h2>
				<p>是否确定删除</p>
			</div>
		</dialogBox>
		<div class="cyTop">
			<div class="cyDelBtn cyDelBtns" @click="fxFlag = true">
				<img src="@/assets/img/编组 (12).png" alt="" />
				获取试卷
			</div>
			<div class="cyDelBtn" @click="delQbFn">
				<img src="@/assets/img/编组 (11).svg" alt="" />
				全部删除
			</div>
		</div>
		<div class="cyCont">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" header-row-class-name="btClass" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" prop="status" :selectable="checkSelectable" width="80"></el-table-column>
				<el-table-column align="center" prop="title" label="试卷名">
					<template slot-scope="scope">
						<div class="spBox" @click="lookBtn(scope.row)">
							{{ scope.row.title }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="难易度">
					<template slot-scope="scope">
						<div class="nydBox">
							{{ scope.row.difficultyScore || 0 }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="报告" align="center">
					<template slot-scope="scope">
						<div class="reportActions">
							<div class="iconBox" @click="ctFn(scope.row)">
								<img src="@/assets/img/ctfb.svg" class="ztIcon" alt="" />错题分布
							</div>
							<div class="iconBox reportEntry" @click="reportFn(scope.row)">
								<i class="el-icon-data-analysis"></i>答题统计
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'banjiSj',
	data() {
		return {
			tableData: [],
			ruleForm: {
				examId: ''
			},
			rules: {
				examId: [{ required: true, message: '请选择试卷', trigger: 'change' }]
			},
			fullscreenLoading: false,
			delFlag: false,
			fxFlag: false,
			options: [],
			bjList: [],
			tabFlag: 1,
			multipleSelection: []
		};
	},
	components: {
		dialogBox
	},
	props: ['bjId', 'a'],
	methods: {
		lookBtn(item) {
			this.$router.push({
				path: './timDec',
				query: {
					type: 1,
					types: 'zt',
					txt: item.title,
					tabFtxt: this.a,
					groupExamId: item.examId,
					crumFlag: 1,
					tabFtxt: ['首页', '班级试卷']
				}
			});
		},
		subFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let { examId } = this.ruleForm;
					let set = this.$loading(this.$pre);
					this.$http
						.post(`api/app/yydBjExam/add`, {
							bjId: this.bjId,
							examId,
							type: 3
						})
						.then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									message: '获取成功',
									type: 'success'
								});
								this.init();
								this.fxFlag = false;
							}
						});
					this.$refs.ruleForm.resetFields();
				}
			});
		},
		decFn() {
			this.$emit('fhBtn', 'kebenDec');
		},
		delQbFn() {
			if (this.multipleSelection.length) {
				let str = '';
				let strName = '';
				for (let item of this.multipleSelection) {
					str += item.bjExamId + ',';
					strName += item.title + ',';
				}
				this.$confirm(`是否删除${strName.substring(0, strName.length - 1)}?`, '提示', {
					confirmButtonText: '确认',
					confirmButtonClass: 'delBtns',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						console.log(str);
						let set = this.$loading(this.$pre);
						this.$http.delete(`api/app/yydBjExam/${str.substring(0, str.length - 1)}`).then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.init();
							}
						});
					})
					.catch(() => {});
			} else {
				this.$message({
					message: '请勾选试卷',
					type: 'warning'
				});
			}
			console.log(this.multipleSelection);
		},
		ctFn(item) {
			this.$emit('ctFn', item.bjExamId);
			this.$emit('fbBtn', item.examId, 5);
			this.$emit('fhBtn', 'banjiSjDecSec');
		},
		reportFn(item) {
			this.$emit('answerReportFn', { examId: item.examId, bjExamId: item.bjExamId, title: item.title, reportSource: 'classExam' });
			this.$emit('fhBtn', 'dailyAnswerReport');
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		checkSelectable(row) {
			return !row.status;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydGroupQuestionExam/listNoBj/${this.bjId}`).then((res) => {
				if (res.code == 200) {
					this.bjList = res.rows || [];
					console.log(res, 1111);
				}
			});
			this.$http.get(`api/app/yydBjExam/list/${this.bjId}/3`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					this.tableData = res.rows || [];
					console.log(res, 9999);
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.spBox {
	cursor: pointer;
}
.fxP {
	font-size: 14px;
	text-align: center;
	margin-bottom: 33px;
}
.cyBox {
	background: #ffffff;
	border-radius: 6px;
	.cyTop {
		height: 80px;
		padding: 0 21px 0 16px;
		display: flex;
		align-items: center;
		position: relative;
		justify-content: space-between;
		border-bottom: 1px solid #eeeff2;
		.cyDelBtn {
			width: 90px;
			height: 30px;
			background: rgba(247, 85, 45, 0.05);
			border: 1px solid #f7552d;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #f7552d;
			cursor: pointer;
			img {
				width: 14px;
				height: 14px;
				margin-right: 4px;
			}
		}
		.cyDelBtns {
			color: #fff;
			background: #1d7b3a;
			border: 1px solid #1d7b3a;
			img {
				width: 12px;
				height: 15px;
				margin-right: 4px;
			}
		}
	}
}
.imgs {
	width: 44px;
	height: 55px;
	background: #d8d8d8;
	border-radius: 4px;
}
.iconBox {
	display: flex;
	align-items: center;
	color: #fa4a1b;
	font-size: 14px;
	justify-content: center;
	cursor: pointer;
	img {
		width: 15px;
		height: 15px;
		margin-right: 6px;
	}
}
.reportActions { display: flex; align-items: center; justify-content: center; gap: 26px; }
.reportEntry { color: #1d7b3a; i { margin-right: 6px; font-size: 16px; } }
.delBox {
	text-align: center;
	img {
		width: 70px;
		height: 70px;
		margin-bottom: 39px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9d9d9d;
		font-size: 16px;
	}
}
.nydBox {
	width: 53px;
	height: 30px;
	border: 1px solid #1d7b3a;
	font-size: 14px;
	color: #1d7b3a;
	border-radius: 6px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
